import {
	designTokens,
	RiArrowLeftSLine,
	RiArrowRightSLine,
	RiCloseCircleLine
} from "@itandi/itandi-bb-ui";
import { IconButton } from "@itandi/itandi-bb-ui/IconButton";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import type { DealReportImage } from "~/models/DealReportImage";
import Styles from "./ImagePreviewModal.module.scss";

type Props = {
	handleClose: () => void;
	initialIndex: number;
	reportImages: DealReportImage[];
};

const customStyles = {
	content: {
		background: "none",
		border: "none",
		inset: 0,
		overflow: "auto",
		padding: "0",
		width: "100%"
	},
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: designTokens["z-index/modal"]
	}
} as const satisfies ReactModal.Styles;

ReactModal.setAppElement("body");

export function ImagePreviewModal({
	reportImages,
	initialIndex,
	handleClose
}: Props) {
	const [currentIndex, setCurrentIndex] = useState(initialIndex);

	const currentImage = reportImages[currentIndex];

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			switch (event.key) {
				case "ArrowLeft":
					event.preventDefault();
					setCurrentIndex((prev) => Math.max(0, prev - 1));
					break;
				case "ArrowRight":
					event.preventDefault();
					setCurrentIndex((prev) =>
						Math.min(reportImages.length - 1, prev + 1)
					);
					break;
				case "Escape":
					event.preventDefault();
					handleClose();
					break;
			}
		};

		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [reportImages, handleClose]);

	return (
		<ReactModal
			isOpen
			onRequestClose={handleClose}
			shouldCloseOnOverlayClick
			style={customStyles} // TODO: customStylesのせいで効かない
		>
			<div className={Styles.ModalDialog}>
				<div className={Styles.NavButtonLeft}>
					<IconButton
						aria-label="前の画像"
						disabled={currentIndex === 0}
						Icon={RiArrowLeftSLine}
						onClick={(e): void => {
							e.stopPropagation();
							setCurrentIndex(currentIndex - 1);
						}}
						variant="secondary"
					/>
				</div>

				<div className={Styles.NavButtonRight}>
					<IconButton
						aria-label="次の画像"
						disabled={currentIndex === reportImages.length - 1}
						Icon={RiArrowRightSLine}
						onClick={(e): void => {
							e.stopPropagation();
							setCurrentIndex(currentIndex + 1);
						}}
						variant="secondary"
					/>
				</div>

				<div className={Styles.ImageFrame}>
					<div>
						<img
							alt="報告画像"
							className={Styles.Image}
							src={currentImage.imageUrl}
						/>
					</div>
					<div className={Styles.CloseArea}>
						<button
							className={Styles.ModalCloseButton}
							onClick={handleClose}
							type="button"
						>
							<RiCloseCircleLine className={Styles.CloseIcon} />
						</button>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}
